import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ availableGateways, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (availableGateways.loading) {
      return "is Loading";
    }
    if (isEmpty(availableGateways.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Name</th>
            <th>Online</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {availableGateways.data.map(availableGateways => (
            <tr key={availableGateways.id}>
              <td>
                <a>{availableGateways.id}</a>
              </td>
              <td>{availableGateways.title}</td>
              <td>{availableGateways.name}</td>
              <td>{availableGateways.online ? "Yes" : "No"}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/available-gateways/${availableGateways.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(availableGateways.id)}
                    to={`/available-gateways/${availableGateways.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/AvailableGateway/Index/Table.js